module.exports = __webpack_public_path__ + "img/jd.c2892462.png";